/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import { Outlet } from "react-router-dom";
import Header from "components/header/header";
import BackgroundWrapper from "components/Background";

function Layout() {
    return (
        <BackgroundWrapper>
            <div className="flex flex-col h-screen">
                <Header />
                <Outlet />
            </div>
        </BackgroundWrapper>

    );
}

export default Layout;
